// RefundPolicy.jsx
import React from 'react';
import Layout from '@/components/Layout';

const RefundPolicy = ({ user }) => {
  return (
    <Layout user={user}>
      <main className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8" role="main">
        <article className="prose lg:prose-lg">
          <h1 className="text-3xl font-bold font-primary text-emerald-950 mb-6 border-b border-zinc-200 pb-4">
            Refund and Cancellation Policy
          </h1>

          <p className="text-zinc-700">
            As we sell edible items, there are <strong>no refunds, returns, or replacements</strong>. <strong>All sales are final.</strong>
          </p>
        </article>
      </main>
    </Layout>
  );
};

export default RefundPolicy;